import { createSlice } from '@reduxjs/toolkit';
import { MenuItemDto } from '../api-types';
import type { RootState } from './store';
import { MenuItemType } from '../api-types/models/MenuItemDto';

export interface MenuState {
    menuType: MenuItemType;
    editItem?: MenuItemDto;
    preparedMenuItems: { [key: string]: MenuItemDto[] };
    preparedConstantMenuItems: MenuItemDto[];
}

const initialState: MenuState = {
    menuType: MenuItemType.KITCHEN,
    preparedMenuItems: {},
    preparedConstantMenuItems: []
};

export const menuItemsSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        changeMenuType(state, action) {
            return {
                ...state,
                menuType: action.payload
            };
        },
        setEditItem(state, action) {
            return {
                ...state,
                editItem: action.payload
            };
        },
        addPreparedMenuItem(state, action) {
            const { menuItem } = action.payload;

            return {
                ...state,
                preparedMenuItems: {
                    ...state.preparedMenuItems,
                    [action.payload.date]: Object.keys(
                        state.preparedMenuItems
                    ).includes(action.payload.date)
                        ? [
                              ...state.preparedMenuItems[action.payload.date],
                              menuItem
                          ]
                        : [menuItem]
                }
            };
        },
        addPreparedConstantMenuItems(state, action) {
            const { menuItems } = action.payload;

            return {
                ...state,
                preparedConstantMenuItems: [
                    ...state.preparedConstantMenuItems,
                    ...menuItems
                ]
            };
        },
        removePreparedMenuItems(state) {
            return {
                ...state,
                preparedMenuItems: {}
            };
        },
        removePreparedConstantMenuItems(state) {
            return {
                ...state,
                preparedConstantMenuItems: []
            };
        }
    }
});

export const selectMenuType = (state: RootState): MenuItemType =>
    state.menu.menuType;

export const selectEditItem = (state: RootState): MenuItemDto | undefined =>
    state.menu.editItem;

export const selectPreparedMenuItems = (
    state: RootState
): { [key: string]: MenuItemDto[] } => state.menu.preparedMenuItems;

export const selectPreparedConstantMenuItems = (state: RootState) =>
    state.menu.preparedConstantMenuItems;

export const {
    changeMenuType,
    setEditItem,
    addPreparedMenuItem,
    removePreparedMenuItems,
    addPreparedConstantMenuItems,
    removePreparedConstantMenuItems
} = menuItemsSlice.actions;

export default menuItemsSlice.reducer;
